import Request from '../util/request'

const path = "eip-mapp-umc-server/"
const bpmPath = "eip-mapp-bpm-working-server/"

export function getData(data) {
    return Request({
      url: path + 'workbench/findBasicApps',
      method: 'post',
      data
    })
  }

export function listAppDetailTreeByAppID(data) {
    return Request({
      url: path + 'workbench/sysFunAppDetailTreeByAppID',
      method: 'post',
      data
    })
  }

export function getFlow(data) {
  return Request({
    url: bpmPath + 'procDef/listProcessByServiceName',
    method: 'post',
    data
  })
}
export function findBasicAppsByOpenType(data) {
  return Request({
    url: path + 'workbench/findBasicAppsByOpenType',
    method: 'post',
    data
  })
}
export function getRecentlyUserdProc(data) {
  return Request({
    url: bpmPath + '/history/proc/getRecentlyUserdProc',
    method: 'get',
    data
  })
}
